import React from "react"
import { JourneyTalkedToDoctorContainer } from "components/views/fle/journey/JourneyTalkedToDoctorContainer"

const JourneyInitialConsult = ({ next, history }) => (
  <JourneyTalkedToDoctorContainer
    title="Have you had an initial fertility consultation?"
    next={next}
    history={history}
  />
)

export { JourneyInitialConsult }
